module.exports = __webpack_public_path__ + "img/file.c3d1a729.svg";